export default "__VITE_ASSET__DDH2nNsK__"